// Central content source — real sales copy (Spanish). No lorem ipsum.
export const CART_URL =
  'https://dnha4i-gj.myshopify.com/cart/add?id=55776420200740&quantity=1';
export const pains = [
  {
    title: 'Organizar las viandas sin ayuda te suma una preocupación más',
    body: 'Además de resolver el trabajo, la casa y el colegio, todos los días tenés que pensar un almuerzo diferente para tu hijo.',
  },
  {
    title: 'Te cuesta encontrar opciones nutritivas que también le gusten',
    body: 'Querés mandarle comidas que le hagan bien, pero también necesitás que sean ricas, prácticas y que no vuelvan intactas en la vianda.',
  },
  {
    title: 'Te frustra que tu hijo rechace cada comida nueva',
    body: 'Cuando intentás variar, aparecen los rechazos o las discusiones y terminás recurriendo otra vez a las pocas opciones que sabés que acepta.',
  },
  {
    title: 'Querés reducir los ultraprocesados sin convertir cada almuerzo en una pelea',
    body: 'Buscás reemplazar las comidas industriales por opciones más caseras y nutritivas, pero necesitás recetas ricas, prácticas y atractivas.',
  },
  {
    title: 'No sabés qué comprar para tener las viandas de la semana resueltas',
    body: 'Vas al supermercado sin un menú claro, comprás ingredientes sin saber cómo combinarlos y a los pocos días volvés a quedarte sin ideas.',
  },
];
export const benefits = [
  {
    title: '250 recetas listas para elegir',
    body: 'Dejá de empezar desde cero cada vez que tengas que preparar un almuerzo.',
  },
  {
    title: 'Sabé qué comprar cada semana',
    body: 'Resolvé las viandas de toda la semana con mayor organización y menos improvisación.',
  },
  {
    title: 'Menos ultraprocesados',
    body: 'Incorporá alternativas más caseras, ricas y fáciles de preparar, sin peleas.',
  },
  {
    title: 'Nuevos alimentos, sin resistencia',
    body: 'Aprendé a incorporar comidas nuevas de una forma atractiva, sin cambiar todo el menú de golpe.',
  },
  {
    title: 'Una rutina más simple',
    body: 'Las viandas dejan de ser una preocupación diaria y se vuelven una parte más fácil de tu día.',
  },
  {
    title: 'Tranquilidad todos los días',
    body: 'Sentí la calma de saber que tu hijo va a disfrutar su vianda, comida rica y casera.',
  },
];
export const bonuses = [
  {
    n: 'BONO 1',
    title: 'Lista de supermercado y sustitutos',
    body: 'Una guía práctica para saber qué comprar y con qué reemplazar cada ingrediente cuando no lo tenés en casa.',
    value: '$4.500',
    emoji: '🛒',
  },
  {
    n: 'BONO 2',
    title: '20 recetas de snacks dulces y salados',
    body: 'Ideas fáciles y ricas para resolver meriendas, recreos o momentos entre comidas con opciones caseras.',
    value: '$3.900',
    emoji: '🍪',
  },
  {
    n: 'BONO 3',
    title: '25 recetas de jugos y batidos',
    body: 'Bebidas frescas, nutritivas y llenas de sabor para sumar frutas y nuevos ingredientes de forma más atractiva.',
    value: '$3.900',
    emoji: '🥤',
  },
  {
    n: 'BONO 4',
    title: 'Guía post colegio con hambre y mal humor',
    body: 'Consejos y opciones rápidas para ese momento del día en el que tu hijo vuelve cansado, con hambre y poca paciencia.',
    value: '$3.500',
    emoji: '🥪',
  },
  {
    n: 'BONO 5',
    title: 'Técnicas para que se anime a probar algo nuevo',
    body: 'Estrategias fáciles para presentar nuevos alimentos con más calma, curiosidad y menos resistencia, sin pelea ni forzarlo.',
    value: '$3.900',
    emoji: '✨',
  },
  {
    n: 'BONO 6',
    title: 'Calendario semanal + stickers + rótulos imprimibles',
    body: 'Organizá las viandas de la semana de forma simple y divertida con material imprimible listo para usar.',
    value: '$4.290',
    emoji: '🗓️',
  },
];
export const testimonials = [
  { quote: 'Es una guía completísima y muy práctica. Las recetas son fáciles de entender y están pensadas para la rutina real de una mamá.', name: 'Carolina M.' },
  { quote: 'Mi hija probó alimentos que antes rechazaba solamente por presentarlos de otra manera.', name: 'Valeria R.' },
  { quote: 'Excelente ebook. ¡Me solucionó uno de los mayores problemas de la semana!', name: 'Lucía P.' },
  { quote: 'Mi hijo es bastante difícil con la comida y ya encontró varias recetas que le gustan.', name: 'Mariana T.' },
  { quote: 'Pensé que sería solamente un listado de recetas, pero está muy bien organizado y realmente ayuda a planificar. Lo recomiendo muchísimo.', name: 'Sofía G.' },
  { quote: 'Es ideal para las mamás que estamos cansadas de pensar un almuerzo diferente cada mañana. Hay opciones para todos los gustos y momentos.', name: 'Daniela F.' },
  { quote: 'La guía me ayudó a salir de las tres comidas de siempre y, lo mejor, es que mis hijos las comen.', name: 'Paula S.' },
  { quote: 'Por fin dejé de mandar siempre las mismas comidas. ¡Gracias!', name: 'Romina L.' },
  { quote: 'No saben la felicidad que me da abrir la vianda y encontrarla vacía.', name: 'Andrea C.' },
  { quote: 'Estoy chocha con esta guía, mi hija me empezó a preguntar qué receta le voy a preparar para el día siguiente.', name: 'Julieta B.' },
];
export const faqs = [
  {
    q: '¿Qué voy a encontrar dentro del ebook?',
    a: 'Vas a acceder a 250 recetas para viandas escolares, pensadas para que puedas ofrecerle a tu hijo almuerzos nutritivos y variados durante más de 10 meses escolares, sin tener que empezar de cero todos los días.',
  },
  {
    q: '¿Me sirve si mi hijo es selectivo con la comida?',
    a: 'Sí. La variedad de recetas te permite buscar opciones que se adapten mejor a sus gustos y comenzar con ingredientes que ya conoce. La idea no es cambiar toda su alimentación de un día para otro, sino incorporar nuevas comidas de manera gradual y atractiva.',
  },
  {
    q: '¿Necesito tener experiencia cocinando?',
    a: 'No. El ebook está pensado para madres y padres que necesitan ideas prácticas para resolver las viandas, incluso aunque no tengan mucha experiencia en la cocina.',
  },
  {
    q: '¿Las recetas están pensadas para almuerzos escolares?',
    a: 'Sí. Las propuestas están enfocadas en preparar comidas para que tu hijo lleve como almuerzo al colegio, ayudándote a salir de las opciones repetidas o improvisadas.',
  },
  {
    q: '¿Realmente me va a ayudar a organizarme?',
    a: 'Sí. En lugar de pensar cada día qué cocinar, vas a tener 250 alternativas reunidas en un mismo lugar, lo que te permitirá elegir con anticipación, organizar mejor las viandas y saber qué ingredientes comprar.',
  },
  {
    q: '¿Me ayudará a reducir los ultraprocesados?',
    a: 'El ebook te dará más opciones caseras, nutritivas y atractivas para reemplazar progresivamente algunas comidas industriales, sin tener que hacer cambios extremos ni convertir cada almuerzo en una discusión.',
  },
  {
    q: '¿Qué pasa si mi hijo rechaza alguna receta?',
    a: 'Es normal que no todos los chicos acepten todas las comidas. Por eso, contar con 250 recetas te permite probar diferentes opciones, adaptar sabores y encontrar aquellas que mejor funcionen para tu hijo.',
  },
  {
    q: '¿Cuánto tiempo voy a ahorrar con el ebook?',
    a: 'El principal ahorro está en dejar de buscar ideas sueltas, improvisar a último momento o preguntarte todos los días qué cocinar. Tendrás una fuente de consulta lista para elegir la próxima vianda con rapidez y tranquilidad.',
  },
  {
    q: '¿Desde qué dispositivo puedo consultar el ebook?',
    a: 'Al ser un producto digital, podrás guardarlo y consultarlo cómodamente desde tu celular, computadora o tablet siempre que necesites buscar una nueva receta.',
  },
];
export const IMAGES = {
  hero: 'https://d2ol7oe51mr4n9.cloudfront.net/user_3GeWFiZP7uNf3rZa8lVb2kVnC39/e96cf294-2732-465b-bf72-a00c3b2f2331.png',
  transformation: 'https://cdn.magicpatterns.com/uploads/qQcx8Beg3WpPeH5GXztGp9/hf_20260722_210735_c7693d3b-7ff5-4b52-9c2d-5f8e0dfc2275_(1).png',
  lunchbox: 'https://d2ol7oe51mr4n9.cloudfront.net/user_3GeWFiZP7uNf3rZa8lVb2kVnC39/a52d8334-2845-497d-9dd9-aafb66344724.png',
  ebookPreview: 'https://d2ol7oe51mr4n9.cloudfront.net/user_3GeWFiZP7uNf3rZa8lVb2kVnC39/36d0db6c-c88a-46c0-9d68-e931e750453d.png',
  offerBundle: 'https://d2ol7oe51mr4n9.cloudfront.net/user_3GeWFiZP7uNf3rZa8lVb2kVnC39/65488cef-329e-4eb1-9e4c-116d2216c361.png',
};